import { FC, ReactNode } from "react";
import { BoostingCampaignScoreContributionStrategyEnum } from "@vviinn/user-managment-client-ts/dist/models/BoostingCampaign";

import { NamedTextInput } from "../../../ui/layout/molecules/NamedTextInput";
import { NamedSelect } from "../../../ui/layout/molecules/NamedSelect";
import { NamedRadio } from "../../../ui/layout/molecules/NamedRadio";
import { InfoRow } from "../../../ui/layout";
import { STRATEGY_OPTIONS } from "../constants";
import { boostingPresets, BoostingDraft } from "../hooks/useBoostingDraft";

export const BoostingFormFields: FC<{
  draft: BoostingDraft;
  nameLabel?: string;
  belowName?: ReactNode;
}> = ({ draft, nameLabel = "Name", belowName }) => {
  const {
    name,
    setName,
    preset,
    onPresetChange,
    copyFromId,
    onCopyFromChange,
    boostingCampaign,
    setColumn,
    setStrategy,
    columnOptions,
    boostings,
  } = draft;

  return (
    <>
      <NamedTextInput
        title={nameLabel}
        required
        styleVariant="newPage"
        value={name}
        onChange={({ value }) => setName(value)}
      />
      {belowName}
      <NamedRadio
        title="Configuration"
        value={preset}
        customId="boostingPreset"
        options={Object.entries(boostingPresets).map(([value, title]) => ({
          value,
          title,
          disabled: value === "copy" && !boostings.length,
        }))}
        onChange={onPresetChange}
        disabledMessage="Current site doesn't have boosting campaigns yet"
      />
      {preset === "custom" && (
        <InfoRow infoText="Preferred values can't be configured here. Please set them after creation." />
      )}
      {preset === "copy" && boostings.length > 0 && (
        <NamedSelect
          title="Reference boosting"
          required
          styleVariant="newPage"
          value={copyFromId}
          options={boostings.map((boosting) => ({
            title: boosting.name,
            value: boosting.id ?? "",
          }))}
          onChange={({ value }) => onCopyFromChange(value)}
        />
      )}
      <NamedSelect
        title="Column"
        options={columnOptions}
        value={boostingCampaign.column ?? ""}
        onChange={({ value }) => setColumn(value)}
        styleVariant="newPage"
      />
      <NamedSelect
        title="Boosting strategy"
        options={STRATEGY_OPTIONS}
        value={boostingCampaign.scoreContributionStrategy}
        onChange={({ value }) =>
          setStrategy(value as BoostingCampaignScoreContributionStrategyEnum)
        }
        styleVariant="newPage"
      />
    </>
  );
};
